import { createContext, useState } from "react";

export const TripFiltersContext = createContext({
    destination: '',
    setDestination: () => {},
    boardingDate: '',
    setBoardingDate: () => {},
    arrivalDate: '',
    setArrivalDate: () => {},
    youngPassengers: 1,
    setYoungPassengers: () => {},
    oldPassengers: 0,
    setOldPassengers: () => {},
});

export const TripFiltersProvider = ({children}) => {
    const [destination, setDestination] = useState('');
    const [boardingDate, setBoardingDate] = useState('');
    const [arrivalDate, setArrivalDate] = useState('');
    const [youngPassengers, setYoungPassengers] = useState(1);
    const [oldPassengers, setOldPassengers] = useState(0);

    const value = {
        destination,
        setDestination,
        boardingDate,
        setBoardingDate,
        arrivalDate,
        setArrivalDate,
        youngPassengers,
        setYoungPassengers,
        oldPassengers,
        setOldPassengers
    };

    return <TripFiltersContext.Provider value={value}>{children}</TripFiltersContext.Provider>;
}